export const bodyFont = 'Arial, sans-serif';
export const headerFont = `"ElliotBold", ${bodyFont}`;
export const monospace = '"Operator Mono SSm A", "Operator Mono SSm B", monospace';
